import Fornecedor from "@/domain/fornecedores/Fornecedores.js";
import Table from "./Table";
export default class TableFornecedores extends Table {
    constructor() {
        super();
    }


    getHeaders() {
        var headers = [
            { text: "Ações", sortable: false, value: "acoes", show: true, pesq: false, enable: false },
            { text: "Razão Social", value: "xNome", show: true, width: "500px", pesq: true, enable: true },
            { text: "CNPJ", value: "CNPJ", width: "500px", show: true, pesq: true, enable: true },
            { text: "Tipo", value: "trabFiliado", width: "500px", show: true, pesq: false, enable: true },
            { text: "Primeira compra", value: "dtPrimeiraCompra", width: "500px", show: true, pesq: false, enable: true },
            { text: "Última compra", value: "dtUltimaCompra", width: "500px", show: true, pesq: false, enable: true },
            { text: "Menor valor de compra", value: "vlrMin", width: "500px", show: true, pesq: false, enable: true },
            { text: "Maior valor de compra", value: "vlrMax", width: "500px", show: true, pesq: false, enable: true },
            { text: "Compras", value: "qtd", width: "500px", show: true, pesq: false, enable: true },
            { text: "Serviço tomado", value: "qntServico", width: "500px", show: true, pesq: false, enable: true },
            { text: "Data da inclusão", value: "dtInclusao", width: "500px", show: false, pesq: false, enable: true },
            { text: "Nome Fantazia", value: "xFant", width: "500px", show: false, pesq: false, enable: true },
            { text: "IE", value: "IE", width: "500px", show: false, pesq: false, enable: true },
            { text: "Regime", value: "CRT", width: "500px", show: false, pesq: false, enable: true },
            { text: "_id", value: "_id", show: false, pesq: false, enable: false },
            // { text: "customValues", value: "customValues", show: false, pesq: false, enable: false},
            { text: "enderEmit", value: "enderEmit", show: false, pesq: false, enable: false },
            { text: "conta", value: "conta", show: false, pesq: false, enable: false },
            { text: "nfes", value: "nfes", show: false, pesq: false, enable: false },
        ]
        return headers
    }

    setNota(arrayNotas, notas) {

        let newArray = arrayNotas;
        this.loading = false;
        for (var i = 0; i < notas.length; i++) {
            try {
                if(!notas[i].primeiraCompra){
                    throw new Error(`Data inválida para construção`)
                }
                newArray.push(
                    new Fornecedor(
                        notas[i].forn._id,
                        notas[i].forn.dtInclusao,
                        notas[i].forn.produto,
                        notas[i].forn.CNPJ,
                        notas[i].forn.xNome,
                        notas[i].forn.xFant,
                        notas[i].forn.IE,
                        notas[i].forn.CRT,
                        notas[i].qtd,
                        notas[i].vlrMin,
                        notas[i].vlrMax,
                        notas[i].primeiraCompra,
                        notas[i].ultimaCompra,
                        notas[i].servicoTomado,
                        notas[i].forn.CPF,
                        notas[i].forn.customValues,
                        notas[i].forn.enderEmit,
                        notas[i].forn.nfes,
                        notas[i].forn.conta,
                    )
                )


            } catch (err) {
                console.log(`Erro ao instanciar Fornecedor: ${notas[i].forn.xNome} \n\n ${err} `)
            }
        }
        this.pagination.sortBy = 'xNome';
        this.pagination.descending = false;
        if(arrayNotas.length > 0) {
            arrayNotas = [ ...arrayNotas, ...newArray ];
            return arrayNotas;
        }else {
            return newArray;
        }

    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableFornecedores.js